// extracted by mini-css-extract-plugin
export default {"Tooltip":"ServiceFee-module--Tooltip--1c1ws"};